<template>
    <section v-if="hasPermissions(['Days-Off-Schedule Read', 'Days-Off-Schedule Write', 'Days-Off-Schedule Read-Assigned-Schedules'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of Live Schedules created from the Templates. Select the Live Schedule from the dropdown list. The Refresh Icon will update the Live Schedule to be the same as the Template. Click Add Associate to add a name to the Schedule. Choose the Associate name and select the Assignment for each day of the Schedule.
            </p>
        </div>

        <div class="bar-container-live-schedule" style="margin-bottom:20px;">
            <div class="bar-container-live-schedule__search-bar" v-if="parent && Object.keys(parent).length && hasPermissions(['Days-Off-Schedule Read', 'Days-Off-Schedule Read-Assigned-Schedules'])">
                <div class="input-field my-0">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div v-for="(key, index) in rotation_form_format" :key="index" class="bar-container-live-schedule__rotation">
                <select
                    :disabled="key.disabled"
                    :multiple="key.type === 'select-multiple' ? true : false"
                    :size="key.maxlength"
                    @change="search_live_schedules(rotation_data[key.model_name])"
                    class="form-control custom-select"
                    :style="`font-size:12px; ${key.type === 'select-multiple' ? '' : 'height: 32px;'}`"
                    :required="key.required"
                    v-model="rotation_data[key.model_name]"
                >
                    <option value='' v-html="'Select Rotation Templates'"/>
                    <option v-for="(value, i) in array_options[key.model_name]" :key="i" :value="value.decrypted_id" v-html="value.name"/>
                </select>
            </div>
            <div class="bar-container-live-schedule__options" v-if="viewing_schedule != 1 && Object.keys(parent).length && hasPermissions(['Days-Off-Schedule Write'])">
                <div v-if="hasPermissions(['Days-Off-Schedule Write'])"
                    class="btn-group modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2"
                    style="margin-top:-2px;">
                    <button type="button"
                        style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;"
                        v-html="'Delete Options'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                    <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false"
                        style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                        <a class="dropdown-item" href="#" @click="massive_modal_delete(false)" v-html="'Mass Delete'" disabled/>
                        <a class="dropdown-item" href="#" @click="massive_modal_delete(true)" v-html="'Delete All'" />
                    </div>
                </div>
                <button  class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2"  @click="confirmationModal()" v-if="hasPermissions(['Days-Off-Schedule Write'])">Apply Master Days Off</button>
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'live_schedules_template_file'"
                    @data="uploadData($event)"
                    v-if="hasPermissions(['Days-Off-Schedule Write'])"
                />
                <button  class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2"  @click="printSchedule()" v-if="hasPermissions(['Days-Off-Schedule Read'])">Print</button>
            </div>
            <div class="bar-container-live-schedule__cta" v-if="viewing_schedule != 1 && Object.keys(parent).length && hasPermissions(['Days-Off-Schedule Write'])">
                <span class="button__modal text-md-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>
        <Indications />
        <div class="row mb-0 no-gutters templates__grid" v-if="Object.keys(parent).length &&  hasPermissions(['Days-Off-Schedule Read', 'Days-Off-Schedule Read-Assigned-Schedules'])">
            <div class="templates__grid__tabs" style="max-width: 300px">
                <div id="nav-tab" role="tablist" class="nav nav-tabs templates__grid__item d-flex justify-content-between">
                    <a class="templates__grid__tabs__item active rounded" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true" v-html="'View by Associate'" style="width: 50%;" @click="view_by_associate = true"/>
                    <a class="templates__grid__tabs__item rounded" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false" v-html="'View by Assignment'" style="width: 50%;" @click="view_by_associate = false"/>
                </div>
            </div>
        </div>
        <div class="shadow-sm p-2 mb-1 bg-white rounded mt-2">
            <div class="rotation__text w-100" style="color: #34495E" v-if="(viewing_schedule == 1)">
                <div>
                    <span class="fa-stack">
                        <i class="fa fa-square-o fa-stack-2x"></i>
                        <i class="fa fa-info fa-stack-1x"></i>
                    </span> 
                    This schedule started on 
                    <Datepicker
                        :disabled="disabledDates"
                        class="ml-1"
                        v-model="previous_date" 
                        name="previous_date_picker"
                        :wrapper-class="'wrapperClass'"
                        :input-class="'datepicker__input-class'"
                        :format="datepickerFormat"
                        @selected="graphic_previous_table_data"
                        placeholder="No dates available"
                    />
                    <!-- <input
                        class="form-control ml-3"
                        style="font-size:12px; height: 32px; width: 30%; margin-top: -7px; display: inline;"
                        v-model="next_start_date" 
                        type="date"
                        /> -->
                </div>
            </div>
            <div class="rotation__text w-100" v-if="viewing_schedule == 3">
                <div>
                    <span class="fa-stack">
                        <i class="fa fa-square-o fa-stack-2x"></i>
                        <i class="fa fa-info fa-stack-1x"></i>
                    </span> 
                    This schedule will start in 
                    <select
                        class="form-control custom-select ml-3"
                        v-model="next_start_date">
                        <option v-for="(value, i) in all_future_dates" :key="i" :value="value.date" v-html="value.date_to_show"/>
                    </select>
                </div>
            </div>

            <div class="row justify-content-center" id="multiselect__filter" v-if="Object.keys(parent).length && schedules.length && hasPermissions(['Days-Off-Schedule Read'])">
                <div class="col-md-12">
                    <multiselect v-model="filtered_items" :options="filtered_options" :multiple="true" :close-on-select="false" :clear-on-select="false" :taggable="true" :preserve-search="true" :placeholder="`Filter by ${(view_by_associate) ? 'associate' : 'daily assignment' }`" label="name" track-by="name" :preselect-first="true">
                        <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen" >{{ values.length }} {{ (view_by_associate) ? 'Associate(s)' : 'Daily assignment(s)' }} selected</span></template>
                    </multiselect>
                </div>
            </div>
            <ScheduleTable
                :parent="parent"
                :schedules="schedules"
                :form_data="form_data"
                :view_by_associate="view_by_associate"
                :editable="(viewing_schedule == 1) ? false : true"
                :viewing_schedule="viewing_schedule"
                :prior_start_date="viewing_schedule == 3 ? next_start_date  : (viewing_schedule == 2) ? prior_start_date : moment(previous_date).format('DD/MM/YYYY')"
                @setNewAssignment="setNewAssignment($event)"
                @setMainAssignment="setMainAssignment($event)"
                @setNewAssociate="setNewAssociate($event)"
                @setAssociates="setAssociates($event)"
                used_in="live_schedules"
                ref="schedule_table"
            />

         </div>
         <div class="row" v-if="hasPermissions(['Days-Off-Schedule Read'])">
            <div class="templates__grid__tabs_parent mx-auto justify-content-center" :style="Object.keys(parent).length ? 'display: block' : 'display:none'">
                <div class="templates__grid__tabs--schedules shadow-sm  bg-white rounded">
                    <div id="nav-tab" role="tablist" class="nav nav-tabs templates__grid__item d-flex">
                        <a class="templates__grid__tabs__item shadow-sm bg-body" :class="viewing_schedule == 1 ? 'active' :''" id="previous-schedule-tab" data-toggle="tab" 
                        href="#previous-schedule" role="tab" aria-controls="future-schedule" aria-selected="true" v-html="'Previous Schedules'" 
                        style="width: 33.333%;"
                        @click="viewing_schedule = 1"/>
                        <a class="templates__grid__tabs__item shadow-sm bg-body" :class="viewing_schedule == 2 ? 'active' :''" id="schedule-actual-tab" data-toggle="tab" 
                        href="#schedule-actual" role="tab" aria-controls="schedule-actual" aria-selected="true" v-html="'Current Schedule'" 
                        style="width: 33.333%;"
                        @click="viewing_schedule = 2"/>
                        <a class="templates__grid__tabs__item shadow-sm bg-body" :class="viewing_schedule == 3 ? 'active' :''" id="future-schedule-tab" data-toggle="tab" 
                        href="#future-schedule" role="tab" aria-controls="future-schedule" aria-selected="false" v-html="'Future Schedules'" 
                        style="width: 33.333%;"
                        @click="viewing_schedule = 3"/>
                    </div>          
                </div>
            </div>
         </div>

        <DeletionMassiveModal
            @objectDeletion="deleteEvent($event)"
            :title="delete_title"
            :message="delete_message"
        />

        <FormModal 
            :title="'New Live Schedule'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :rotation="rotation_data"
            :parent="parent"
            :next_start_date="next_start_date"
            :form_data="form_data"
            :schedules="schedules"
            :form_backup="form_backup"
            :array_options="array_options"
            :schedule_options="schedule_options"
            :daily_assignment_options="daily_assignment_options"
            @unshiftObject="unshift_object($event)"
        />

        <FormModalAssignment 
            :parent="parent"
            :rotation="rotation_data"
            :viewing_schedule="viewing_schedule"
            :next_start_date="next_start_date"
            :breadcrumb="breadcrumb"
            :rest_api="ext_rest_api"
            :parent_rest_api="rest_api"
            :notyf="notyf"
            :array_options="array_options"
            :schedules="schedules"
            :indexes="indexes"
            :view_by_associate="view_by_associate"
            @spliceObject="splice_template_object($event)"
            ref="modalAssignment"
        />
        <FormModalAssociate 
            :title="'Set Associate'"
            :breadcrumb="breadcrumb"
            :rest_api="associate_rest_api"
            :rotation="rotation_data"
            :next_start_date="next_start_date"
            :schedules="schedules"
            :indexes="indexes"
            :notyf="notyf"
            :single_object="template_object"
            :template_index="template_index"
            :schedule_index="schedule_index"
            :array_options="array_options"
            :view_by_associate="view_by_associate"
            @spliceObject="splice_schedule_object($event)"
            ref="modalAsssociate"
        />
        <UploadSummary 
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="name_file_summary"
        />

        <HelperModal :helps="helps"/>

        <WaitingModal/>
    </section>
    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>

import Breadcrumb           from '@/components/BreadcrumbComponent/Breadcrumb'
import DeletionMassiveModal from '@/components/DeletionMassiveModal'
import WaitingModal         from '@/components/WaitingModal'
import Resources            from './resources'
import FormResources        from './form_resources'
import FormModal            from './FormModal'
import FormModalAssignment  from './FormModalAssignment'
import Indications from './Indications.vue'
import FormModalAssociate  from './FormModalAssociate'
import ScheduleTable         from    './ScheduleTable'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
import HelperModal          from    '@/components/HelperModal'
import moment from 'moment'
import 'vuetify/dist/vuetify.min.css'
import { Notyf }            from    'notyf'
import 'notyf/notyf.min.css'; // for React and Vue

import Multiselect  from    "vue-multiselect"
import Datepicker from 'vuejs-datepicker';


const notyf = new Notyf({
    duration: 8000,
});
export default {
    
    name: 'Schedule',

    components: {
    Breadcrumb,
    WaitingModal,
    FormModal,
    FormModalAssociate,
    FormModalAssignment,
    DeletionMassiveModal,
    ScheduleTable,
    Multiselect,
    UnauthorizedComponent,
    Datepicker,
    UploadOptions,
    UploadSummary,
    Indications,
    HelperModal
},

    data() {
      return {
        notyf,
        title_page:         'Live Schedules',
        user:               this.get_user(),
        rest_api:           `schedules`,
        ext_rest_api:       `live_schedule_set_assignment`,
        associate_rest_api: `live_schedule_set_associate`,
        table_headers:      Resources.table_headers,
        breadcrumb:         Resources.breadcrumb,
        excel_file_headers: {},
        empty_format_data:  Resources.empty_format_data,
        moment,

        /** */
        rotation_form_format:      FormResources.rotation_form_format,
        rotation_data:             FormResources.rotation_data,
        schedule_options:          FormResources.schedule_options,
        daily_assignment_options:  [],
        daily_assignment_position: [],
        /** */

        form_data:   FormResources.form_data,
        form_backup: {...FormResources.form_data},

        add_btn:                'Add Associate',
        single_select:          false,
        table_selection:        [],
        search:                 '',

        global_index:           undefined,
        template_index:         undefined,
        schedule_index:         undefined,

        single_object:          {},
        template_object:        {},

        parent:                 {},
        schedules:              [],
        backup_parent:          [],
        backup_schedules:        {},
        daily_assignments:      [],
        array_options:          {},
        schedule_header:        [],
        select_ids:             [],

        filtered_items:    [],
        filtered_options:   [],
        all_future_dates:       [],
        see_future_schedule: null,
        viewing_schedule: 2,
        next_start_date: null,
        prior_start_date: null,
        indexes: null,
        view_by_associate: true,
        disabledDates:  {
            days: [0,1,2,3,4,5,6]
        },
        previous_date: '',
        name_file_summary: 'live_schedules_failed_template_file',
        summary: [],
        excel_data: [],
        
        all_previous_dates: {
            dates: [],
        },
        clean_all: false,
        delete_title: undefined,
        delete_message: undefined,
        helps:              Resources.helps
      }
    },

    watch:
    {
        filtered_items()
        {
            if(this.schedules.length)
            {
                this.schedules.map(schedule => 
                {
                    if(this.view_by_associate)
                {
                    if(schedule.associate_id)
                    {
                        if(this.filtered_items.find(associate => associate.id === schedule.associate_id))
                        {
                            schedule.show = true
                        }
                        else
                        {
                            schedule.show = false
                        }
                    }
                }
                else
                {
                    if(schedule.daily_assignment_id)
                    {
                        if(this.filtered_items.find(daily_assignment => daily_assignment.id === schedule.daily_assignment_id))
                        {
                            schedule.show = true
                        }
                        else
                        {
                            schedule.show = false
                        }
                    }
                }
                })
            }
        },

        async 'next_start_date'(val)
        {
            if(val)
            {
                this.graphic_future_table_data(this.$route.query.schedule_id)
            }


        },

        async 'viewing_schedule'(val)
        {
            this.rest_api = (this.viewing_schedule == 3) ? 'future_schedules' : (this.viewing_schedule == 1) ? 'previous_schedules' : 'schedules'
            this.ext_rest_api = (this.viewing_schedule == 3) ? 'future_schedule_set_assignment'      : (this.viewing_schedule == 1) ? '' : 'live_schedule_set_assignment'
            this.associate_rest_api = (this.viewing_schedule == 3) ? 'future_schedule_set_associate' : (this.viewing_schedule == 1) ? '' : 'live_schedule_set_associate'
            
            this.next_start_date = null;

            if(val == 3)
            {
                await this.searchFutureDates()
               
            }
            else if(val == 2)
            {
                await this.search_live_schedules(this.rotation_data.rotation_setup_id)

            }
            else if(val == 1)
            {
                await this.searchPreviousDates()
            }
        },

        async 'view_by_associate'()
        {
            if(this.viewing_schedule == 3)
            {
                await this.graphic_future_table_data(this.$route.query.schedule_id)
               
            }
            else if(this.viewing_schedule == 2)
            {
                await this.search_live_schedules(this.rotation_data.rotation_setup_id)

            }
            else if(this.viewing_schedule == 1)
            {
                await this.searchPreviousDates()
            }
        }

    },

    computed:
    {
        selected()
        {
            const bool = this.schedules.filter(item => item.checked)
            return Boolean(bool.length)
        },
    },

    methods: 
    {
        async printSchedule()
        {
            this.loader(true)

            const response = await this.post(`${this.rest_api}/reports/schedule`, { id:  this.parent.id, view_by_associate: this.view_by_associate})
            this.loader()

            if(response.status)
            {
                this.downloadReport(response)
            }
            else
            {
                this.error_handling(response)
            }
        },

        async uploadData(data)
        {
            this.excel_data = data

            this.loader(true)
            const response = await this.put(`${this.rest_api}/massive/${this.$route.query.schedule_id}`, { items: this.excel_data, timestamp: this.getCurrentDateTime(), date: this.next_start_date })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.excel_file_headers = Resources.excel_file_headers
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')

                if(this.viewing_schedule == 3)
                {
                    await this.graphic_future_table_data(this.rotation_data.rotation_setup_id)
                }
                else
                {
                    await this.graphic_table_data(this.rotation_data.rotation_setup_id)
                }
            }
            else
            {
                this.error_handling(response)
            }

            this.$refs.file_excel.clear_data()
        },

        async settingUploadOptions(schedule_header)
        {
            this.excel_file_headers = {...Resources.excel_file_headers}
            schedule_header.forEach(item => {
                const complete_header = `${item.date} - ${item.name}`
                this.excel_file_headers[complete_header] = complete_header
            });
        },

        async search_live_schedules(rotation_id)
        {
            if(rotation_id)
            {
                this.previous_date     = '' 
                this.schedules         = []
                this.daily_assignments = []

                if(this.hasPermissions(['Days-Off-Schedule Read', 'Days-Off-Schedule Read-Assigned-Schedules']))
                {
                    await this.graphic_table_data(rotation_id)
                }
            }
        },

        async graphic_table_data(rotation_id)
        {
            this.loader(true)

            const http_request = {
                id: rotation_id,
                view_by_associate: this.view_by_associate
            }

            const response = await this.post(`schedules/search_schedule`, http_request)

            this.loader()

            if(response.status)
            {    
                let data = response.data;

                this.parent = data.data.rotation_setup !== undefined ? data.data.rotation_setup : null
                this.schedules = data.data.schedules !== undefined ? data.data.schedules : []

                this.backup_parent = {...this.parent}
                this.backup_schedules = JSON.parse(JSON.stringify(this.schedules))

                this.prior_start_date = data.prior_start_date

                this.viewing_schedule = 2;
                    

                this.setAssociatesFilter(rotation_id)
            }
            else
            {
                this.error_handling(response.data)
            }

            await this.$refs.schedule_table.scheduleFormatIncrease()

            this.settingUploadOptions(this.$refs.schedule_table.schedule_header)
        },

        async graphic_future_table_data(rotation_id)
        {
            this.loader(true)

            const http_request = {
                id: rotation_id,
                date: this.next_start_date,
                view_by_associate: this.view_by_associate
            }

            const response = await this.post(`future_schedule/search`, http_request)

            this.loader()

            if(response.status)
            {    
                let data = response.data;

                if(data.data)
                {
                    this.parent = data.data.future_rotation_setup !== undefined ? data.data.future_rotation_setup : null
                    this.schedules = data.data.schedules !== undefined ? data.data.schedules : []

                    this.setAssociatesFilter(rotation_id)
                }
                else
                {
                    this.parent = {...this.backup_parent}
                    this.schedules = []
                    this.setAssociatesFilter(rotation_id)
                }
            }
            else
            {
                this.error_handling(response)
            }

            await this.$refs.schedule_table.scheduleFormatIncrease()

            this.settingUploadOptions(this.$refs.schedule_table.schedule_header)
        },

        async graphic_previous_table_data(date)
        {
            this.loader(true)

            const rotation_id = this.rotation_data.rotation_setup_id

            const http_request = {
                id: rotation_id,
                date: this.convertObjectDateToStringDate(date),
                view_by_associate: this.view_by_associate
            }

            const response = await this.post(`previous_schedule/search`, http_request)

            this.loader()

            if(response.status)
            {    
                let data = response.data;

                if(data.data)
                {

                    this.schedules = data.data.schedules !== undefined ? data.data.schedules : []
                    this.parent = data.data.previous_rotation_setup

                    this.setAssociatesFilter(rotation_id)
                }
                else
                {
                    this.parent = {...this.backup_parent}
                    this.schedules = []
                    this.setAssociatesFilter(rotation_id)
                }
            }
            else
            {
                this.error_handling(response)
            }
            // this.$refs.schedule_table.scheduleFormatIncrease()
        },

        setAssociatesFilter(rotation_id)
        {
            if(this.parent)
            {
                this.filtered_options = this.schedules.map(item =>
                {
                    if(this.view_by_associate)
                    {
                        return {id: item.associate_id, name: item.associate}
                    }

                    return {id: item.daily_assignment_id, name: item.daily_assignment}
                })
                
                this.filtered_items = this.filtered_options;

                this.rotation_data.rotation_setup_id = rotation_id
                
                this.$router.replace({ 
                    path: 'days-off-schedules', 
                    query: { 
                        schedule_id: rotation_id
                    }
                }).catch(()=> {})
            }

        },

        async searchFutureDates()
        {
            this.loader(true)

            const response = await this.get(`future_schedule_all_dates/${this.backup_parent.id}`)

            this.loader()

            if(response.status)
            {
                this.all_future_dates = response.data.all_future_dates;
                if(this.all_future_dates.length)
                {
                    this.next_start_date = this.all_future_dates[0].date
                }
            }
        },

        async searchPreviousDates()
        {
            this.loader(true)

            const response = await this.get(`previous_schedule_all_dates/${this.rotation_data.rotation_setup_id}`)

            this.loader()

            if(response.status)
            {
                this.all_previous_dates.dates = [];

                const previous_dates = response.data.all_previous_dates;

                if(previous_dates.length)
                {
                    previous_dates.forEach(item => 
                    {
                        this.all_previous_dates.dates.push(this.convertStringDateToObjectDate(item.start_date))
                    })

                    this.previous_date = this.all_previous_dates.dates[previous_dates.length - 1]
                    this.graphic_previous_table_data(this.previous_date)
                }
                else 
                {
                    this.schedules = []
                }
            }

            if(this.all_previous_dates.dates.length)
            {
                this.disabledDates.days = []
                this.disabledDates.customPredictor = (date) => 
                {
                    if(this.all_previous_dates.dates.findIndex(item => item.getTime() == date.getTime()) > -1)
                    {
                        return false
                    }

                    return true
                }
            }
            else
            {
                this.disabledDates.days = [0,1,2,3,4,5,6]
            }
        },

        datepickerFormat(date) 
        {
            return moment(date).format('MM/DD/YYYY');
        },

        massive_modal_delete(clean_all)
        {
            this.clean_all = clean_all

            this.delete_title   = undefined
            this.delete_message = undefined
            
            if(!clean_all)
            {
                let local_ids = this.schedules.filter(item => item.checked)

                if(local_ids.length)
                {
                    if(this.view_by_associate)
                    {
                        this.select_ids = local_ids.map(item => item.id)
                    }
                    else
                    {
                        this.select_ids = local_ids.map(item => item.daily_assignment_id)
                    }

                    window.$('#static-deletion-massive').modal('show')
                }
                else
                {
                    this.notyfMesg('No items selected', 'error')
                }
            }
            else
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async deleteEvent()
        {
            if(this.delete_title)
            {
                this.syncWithTemplate()
            }
            else
            {
                this.massive_local_emition()
            }

        },

        async massive_local_emition()
        {
            let sendingMassive;

            if(this.clean_all)
            {
                sendingMassive = await this.cleanAll()
            }
            else
            {
                const full_schedule = this.schedules = JSON.parse(JSON.stringify(this.schedules)) 

                let json_request = {
                    ids: this.select_ids,
                    rotation_id: this.rotation_data.rotation_setup_id,
                    date: this.next_start_date,
                    full_schedule,
                    view_by_associate: this.view_by_associate,
                }

                sendingMassive = await this.massive_delete(json_request)
            }   
            

            if(sendingMassive)
            {
                if(this.viewing_schedule == 3)
                {
                    await this.graphic_future_table_data(this.rotation_data.rotation_setup_id)
                }
                else
                {
                    await this.graphic_table_data(this.rotation_data.rotation_setup_id)
                }
                this.select_ids = []
                this.massive_all = false
            }
        },

        async test()
        {
            await this.get(`previous_schedule/test`)

        },

        async splice_template_object()
        {
            if(this.viewing_schedule == 3)
            {
                await this.graphic_future_table_data(this.rotation_data.rotation_setup_id)
            }
            else
            {
                await this.graphic_table_data(this.rotation_data.rotation_setup_id)
            }
            window.$('#static-assignment').modal('hide')
        },

        async splice_schedule_object()
        {

            if(this.viewing_schedule == 3)
            {
                await this.graphic_future_table_data(this.rotation_data.rotation_setup_id)
            }
            else
            {
                await this.graphic_table_data(this.rotation_data.rotation_setup_id)
            }
            window.$('#static-associate').modal('hide')

        },

        setNewAssignment({index, index_item, date_for_backend})
        {
            if(this.hasPermissions(['Days-Off-Schedule Write']))
            {
                this.indexes = {
                    row_index: index,
                    item_index: index_item
                }

                this.template_object = {...this.schedules[index].rotation_day_assignments[index_item]}
                this.template_object['rotation_id'] = this.parent.encrypt_id
                let is_time_off = (this.template_object.assignments[0] && this.template_object.assignments[0].is_time_off) ? true : false;
                this.$refs.modalAssignment.reset(is_time_off, this.template_object, date_for_backend);
                window.$('#static-assignment').modal('show')
            }
        },

        setMainAssignment(index)
        {
            if(this.hasPermissions(['Days-Off-Schedule Write']))
            {
                this.indexes = {row_index: index}
                this.template_object = {...this.schedules[index]}
                this.template_object['rotation_id'] = this.parent.encrypt_id

                this.$refs.modalAssignment.reset(false, this.template_object);
                window.$('#static-assignment').modal('show')
            }

        },

        setAssociates({index, index_item})
        {
            if(this.hasPermissions(['Days-Off-Schedule Write']))
            {
                this.indexes = {
                    row_index: index,
                    item_index: index_item
                }

                this.template_object = {...this.schedules[index].rotation_day_assignments[index_item]}
                this.template_object['rotation_id'] = this.parent.encrypt_id;
                this.$refs.modalAsssociate.reset(this.template_object);
                window.$('#static-associate').modal('show')
            }
        },

        setNewAssociate(index)
        {
            if(this.hasPermissions(['Days-Off-Schedule Write']))
            {
                this.indexes = {row_index: index}
                this.template_object = {...this.schedules[index]}
                this.template_object['rotation_id'] = this.parent.encrypt_id
                window.$('#static-associate').modal('show')
            }

        },

        async unshift_object()
        {
            this.form_data.new_associates   = []
            this.form_data.associate_id     = ''
            this.form_data.supervisor_id    = ''
            this.form_data.assignment_id    = ''
            this.form_data.rotation_day_id  = ''

            if(this.viewing_schedule == 3)
            {
                await this.graphic_future_table_data(this.rotation_data.rotation_setup_id)
            }
            else
            {
                await this.graphic_table_data(this.rotation_data.rotation_setup_id)
            }
        },

        splice_object(splicing_object)
        {
            this.schedules.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.schedules[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.schedules[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.schedules = []
            this.array_options = {
                rotation_setup_id: data.rotation_setups,
                associate_id: data.associates,
                supervisor_id: data.supervisors,
                daily_assignment_id: data.assignments,
                time_off_id: data.time_offs
            }
            this.daily_assignment_options = data.assignments
        },

        async confirmationModal()
        {
            this.delete_title   = 'Are you sure you want to apply master days off?'
            this.delete_message = 'All schedule items will be deleted and all items created on the master days off will be copied to this schedule'
            window.$('#static-deletion-massive').modal('show')
        },

        async syncWithTemplate()
        {

        this.loader(true)

        let http_object= {
            rotation_id: this.rotation_data.rotation_setup_id,
            date: this.next_start_date
        }

        const data = await this.post(`${this.rest_api}/sync_with_template`, http_object)

        if(data.status)
        {
            if(this.viewing_schedule == 3)
            {
                this.graphic_future_table_data(this.$route.query.schedule_id)
            }
            else
            {
                this.graphic_table_data(this.$route.query.schedule_id)
            }
            window.$('#static-deletion-massive').modal('hide')
            notyf.success('Success!')
        }
        else
        {
            this.error_handling(data.response)
        }

        this.loader()

        },
        async cleanAll()
        {
            const response = await this.massive_delete({rotation_setup_id: this.parent.id, clean_all: true})

            if(response.status)
            {
                this.notyfMesg('Schedule was cleaned')
            }
            else
            {
                this.error_handling(response)
            }

            return true;
        }

    },

    async mounted()
    {
        if(this.hasPermissions(['Days-Off-Schedule Read', 'Days-Off-Schedule Write', 'Days-Off-Schedule Read-Assigned-Schedules']))
        {
            await this.api_request()
        }

        if(this.$route.query.schedule_id)
        {
            await this.graphic_table_data(this.$route.query.schedule_id)
        }
        
    }

}
</script>